import "./TheClinic.module.css";
import Header from "@/reusable_sections/Header";
import SanctuaryOfInk from "./sections/SanctuaryOfInk";
import OurClinicalPhilosophy from "./sections/OurClinicalPhilosophy";
import ReachCalciumHospital from "./sections/ReachCalciumHospital";
import Footer from "@/reusable_sections/Footer";
export default function TheClinicPage() {
  return <div>
      <Header />
      <SanctuaryOfInk />
      <OurClinicalPhilosophy />
      <ReachCalciumHospital />
      <Footer />
    </div>;
}